import { Injectable, inject } from '@angular/core';
import { SymbolType } from '../../../../../domain/symbol.domain';
import { TimezoneService } from '../../../../../services/date/timezone.service';
import { DateService } from '../../../../../services/date/date.service';
import { TradingAccount } from '../../../../../domain/account.domain';
import { GicFormModel, OrderFormParameters, GicOrderStateParameters } from '../../domain/order-entry.domain';
import { CreateOrderFormService } from './create-order-form.service';

@Injectable()
export class CreateOrderGicFormService extends CreateOrderFormService<GicFormModel> {
  protected readonly timezoneService = inject(TimezoneService);

  initializeViewModel(_selectedAccount?: TradingAccount, orderFormParameters?: OrderFormParameters): GicFormModel {
    this.temp = {
      gicList: undefined,
      selectedType: undefined,
      selectedTerm: undefined,
      selectedFrequency: undefined,
      selectedGic: undefined,
      maturityDate: undefined,
      orderAmount: undefined
    } as GicFormModel;
    if (orderFormParameters?.orderStateParameters?.symbol !== undefined) {
      const parameters = orderFormParameters?.orderStateParameters as GicOrderStateParameters;
      this.temp.rateSheetParams = {
        orderType: (parameters.orderType),
        symbol: parameters.symbol === undefined ? undefined : decodeURIComponent(parameters.symbol),
        securityType: SymbolType[parameters.securityType],
        gicType: parameters.gicType,
        gicTerm: parameters.gicTerm,
        gicFrequency: parameters.gicFrequency,
        gicRate: parameters.gicRate
      };
    }
    return Object.assign({}, this.temp); // TODO double check
  }

  getTodaysDate(): Date {
    return DateService.stripTime(this.timezoneService.getCurrentDateInServerTimezone());
  }

  isFutureGicDate(expiryDate: Date): boolean {
    const today = this.getTodaysDate();
    return DateService.getUTCTimeDifferenceInMilliseconds(today, expiryDate) >= 0;
  }
}

